import React from 'react';
import { Bot, Workflow, Database, MessageSquare, BarChart3, Zap } from 'lucide-react';

const services = [
    {
        icon: <Bot className="w-8 h-8 text-brand-cyan" />,
        title: 'AI Automation Systems',
        description: 'Custom AI agents that handle customer support, data processing, and internal queries 24/7.',
    },
    {
        icon: <Workflow className="w-8 h-8 text-brand-blue" />,
        title: 'Workflow Engineering',
        description: 'End-to-end business process automation using n8n, Make, and custom scripts to eliminate manual tasks.',
    },
    {
        icon: <Database className="w-8 h-8 text-brand-orange" />,
        title: 'CRM & API Integrations',
        description: 'Seamlessly connect your CRM, email marketing, and project management tools into one unified system.',
    },
    {
        icon: <MessageSquare className="w-8 h-8 text-brand-coral" />,
        title: 'WhatsApp Automation',
        description: 'Intelligent WhatsApp bots for lead qualification, order updates, and customer engagement.',
    },
    {
        icon: <BarChart3 className="w-8 h-8 text-purple-500" />,
        title: 'Business Intelligence',
        description: 'Automated reporting dashboards that pull data from all your sources into clear, actionable insights.',
    },
    {
        icon: <Zap className="w-8 h-8 text-yellow-500" />,
        title: 'Social Media Ops',
        description: 'Auto-schedule content, reply to comments, and track engagement across all your social platforms.',
    },
];

const Services: React.FC = () => {
    return (
        <section id="services" className="py-24 bg-navy-900 relative">
            <div className="max-w-7xl mx-auto px-6">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                        Intelligent Solutions for Modern Business
                    </h2>
                    <p className="text-text-muted max-w-2xl mx-auto">
                        We don't just connect apps; we build intelligent systems that think, act, and learn to help your business grow.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {services.map((service, index) => (
                        <div
                            key={index}
                            className="group p-8 rounded-2xl bg-navy-800 border border-white/[0.05] hover:border-brand-cyan/30 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-brand-cyan/5"
                        >
                            <div className="w-14 h-14 rounded-xl bg-white/[0.03] grid place-items-center mb-6 group-hover:scale-110 transition-transform duration-300">
                                {service.icon}
                            </div>
                            <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
                            <p className="text-text-muted leading-relaxed">
                                {service.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
